import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import GetStarted from './views/GetStarted.vue'
import Login from './views/Login.vue'
import Verify from './views/Verify.vue'
import Dashboard from './views/Dashboard.vue'
import MyRequest from './views/MyRequest.vue'
import Post from './views/Post.vue'
import Search from './views/Search.vue'
import Future from './views/Future.vue'
import Buy from './views/Buy.vue'
import Sell from './views/Sell.vue'
import MyBids from './views/MyBids.vue'
import firebase from 'firebase'

Vue.use(Router)

var router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
	{
		path : '/getstarted',
		name : 'getStarted',
		component : GetStarted
	},
	{
		path : '/login',
		name : 'Login',
		component : Login,
	},
	{
		path : '/home',
		component : Home,
		redirect : '/home/default',
		meta : {
			requiresAuth : true
		},
		children : [
		{
			path: 'default',
			name: 'Dashboard',
			component: Dashboard,
			meta : {
				requiresAuth : true,
				requiresVerification : true
			}
		},
		{
			path: 'future',
			name: 'Future',
			component: Future,
			meta : {
				requiresAuth : true,
				requiresVerification : true
			}
		},
		{
			path: 'post',
			name: 'My Posts',
			component: Post,
			meta : {
				requiresAuth : true,
				requiresVerification : true
			}
		},
		{
			path: 'search',
			name: 'Search',
			component: Search,
			meta : {
				requiresAuth : true,
				requiresVerification : true
			}
		},
		{
			path: 'myrequest',
			name: 'My Requests',
			component: MyRequest,
			meta : {
				requiresAuth : true,
				requiresVerification : true
			}
		},
		{
			path: 'buy',
			name: 'Buy',
			component: Buy,
			meta : {
				requiresAuth : true,
				requiresVerification : true
			}
		},
		{
			path: 'sell',
			name: 'Sell',
			component: Sell,
			meta : {
				requiresAuth : true,
				requiresVerification : true
			}
		},
		{
			path : 'mybids',
			name : 'My Bids',
			component : MyBids,
			meta : {
				requiresAuth: true,
				requiresVerification: true
			}
		},
		{
			path : 'verify',
			name : "Verify",
			component : Verify,
			meta : {
				requiresAuth : true
			}
		},
		{
			path : '*',
			redirect : '/'
		}
		]
	},

	{
		path: '*',
		redirect : '/getstarted'
	}
	]
});

router.beforeEach((to, from, next)=>{
	let user = firebase.auth().currentUser ;
	let emailVerificationStatus = user ? user.emailVerified : false;
	let requiresAuth = to.matched.some(record => record.meta.requiresAuth);
	let requiresVerification = to.matched.some(record => record.meta.requiresVerification);
	if (user && !requiresAuth) next('/home');
	else if (!user && requiresAuth) next('/login');
	else if (!emailVerificationStatus && requiresVerification) next('/home/verify');
	else next();
})

export default router;